<div class="order-payment-details-view item flex align-items-center">
  <div class="item__icon">
    <mat-icon color="accent" class="custom-icons">payment</mat-icon>
  </div>
  <div class="item__description ms-3">
    <strong>Payment:</strong>
    <span class="payment-status" [ngClass]="paymentStatusClasses">{{ paymentStatusToDisplay }}</span>
  </div>
</div>